{
  "sessionExpired": "Tu sesión expiró - inicia sesión de nuevo",
  "codeVerified": "Tu código fue verificado",
  "passwordChanged": "Tu contraseña fue cambiada",
  "accountCreated": "Tu cuenta fue creada",
  "accountDeleted": "Tu cuenta fue eliminada",
  "unableToDeleteAccount": "No pudimos eliminar tu cuenta, inténtalo de nuevo",
  "bookingDetailsUpdated": "Datos de la reserva actualizados",
  "addStopError": "No se pudo agregar la parada",
  "editStopError": "No se pudo editar la parada",
  "removeStopError": "No se pudo quitar la parada",
  "locationError": "No se pudo obtener la ubicación",
  "defaultAddressError": "No se pudo obtener la dirección predeterminada",
  "delayError": "No se pudo obtener la demora de la reserva",
  "unableToCompletePayment": "No pudimos completar tu pago, inténtalo de nuevo",
  "unableToProceedBooking": "No pudimos continuar con esta reserva, inténtalo de nuevo",
  "unableToAddCard": "No pudimos agregar tu tarjeta, inténtalo de nuevo",
  "unableToDeleteCard": "No pudimos eliminar tu tarjeta, inténtalo de nuevo",
  "unableToDefaultCard": "No pudimos establecer tu tarjeta como predeterminada, inténtalo de nuevo",
  "profileUpdated": "Tu perfil fue actualizado",
  "editProfileError": "No se pudo editar el perfil",
  "cardAdded": "Tu tarjeta fue agregada",
  "cardDeleted": "Tu tarjeta fue eliminada",
  "cardDefaulted": "Tu tarjeta predeterminada fue actualizada",
  "unableToCancelBooking": "No pudimos cancelar esta reserva",
  "unableToEditBooking": "No pudimos editar esta reserva",
  "unableToCopyBooking": "No pudimos copiar esta reserva",
  "favouriteAdded": "Favorito agregado",
  "favouriteCleared": "Favorito quitado",
  "favouriteEdited": "Favorito editado",
  "unableToAddFavourite": "No pudimos agregar este favorito",
  "unableToClearFavourite": "No pudimos quitar este favorito",
  "unableToEditFavourite": "No pudimos editar este favorito",
  "unableToFindBookingTemplate": "No se encontró la plantilla de reserva",
  "unableToSearchForAddresses": "No se pudo buscar direcciones",
  "unableToSearchForContacts": "No se pudo buscar contactos",
  "unableToSearchForReports": "No se pudo buscar reportes",
  "unableToLoadJourneyDetails": "No se pudieron cargar los datos del viaje",
  "secretKeyCopied": "Clave secreta copiada",
  "contactLink": {
    "contactLinkRequestSent": "Solicitud de vínculo de contacto enviada",
    "contactLinkRequestFailed": "La solicitud de vínculo de contacto falló",
    "unableToLoadLinkedContacts": "No se pudieron cargar los contactos vinculados",
    "contactLinkAuthorised": "Vínculo de contacto autorizado",
    "contactLinkRejected": "Vínculo de contacto rechazado"
  },
  "jobDetailsCopied": "Datos del servicio copiados al portapapeles",
  "unableToSignOn": "No se pudo completar el inicio de sesión",
  "vouchers": {
    "voucherRemoved": "Cupón {voucherCode} eliminado",
    "unableToAddVoucher": "No se pudo agregar el cupón",
    "voucherAdded": "Cupón {voucherCode} agregado",
    "voucherAlreadyAdded": "El cupón {voucherCode} ya fue agregado"
  },
  "unableToOpenFile": "No se pudo abrir {file}",
  "missingFormData": "Faltan datos del formulario",
  "missingLeadPassengerDetails": "Faltan los datos del pasajero principal",
  "quickQuoteUnavailable": "Cotización rápida no disponible",
  "reporting": {
    "export": {
      "copyMessage": "Reporte copiado",
      "error": "Error de exportación"
    }
  },
  "deviceIntegrityWarning": "Este dispositivo parece estar modificado, lo que podría poner tus datos en riesgo",
  "newNotification": "Nueva notificación"
}
